import API from "@aws-amplify/api";
import Storage from "@aws-amplify/storage";
import {getLocalized} from "@/store/localizedStorage";
import { InjectionKey } from "vue";
import {
  createStore,
  useStore as baseUseStore,
  Store,
  MutationTree,
  ActionTree,
} from "vuex";
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import { Game, GameState, Localizations, State, Story } from "@/data/game";

const NOSTORY: Game = {
  id: 0,
  abstract: {
    title: "No game available",
    story:
      "To join a dinner enter the 8 digit code",
  },
  players: [],
  rounds: [],
};

const apiName = "murderhungryapi";
const path = "/game";
const state: State = {
  stories: [],
  gameStateId: "",
  game: NOSTORY,
  loggedIn: false,
  username: "",
  locale: "en",
};

function getPart(username: string) {
  return state.gameState ? state.gameState.cast.get(username) : "na";
}

function sendToAPI() {

  API.post(apiName, path, {
    body: {
      gameid: state.gameStateId,
      playerid: getPart(state.username),
      username: state.username,
      token: state.pushToken ? state.pushToken : "na",
      role: getPart(state.username),
    },
  })
    .then((response) => {
      // Add your code here
    })
    .catch((error) => {
      console.log(error.response);
    });
}

export const enum MUTATIONS {
  SET_GAME = "SET_GAME",
  SET_STORY = "SET_STORY",
  SET_STORIES = "SET_STORIES",
  SET_STATE = "SET_STATE",
  SET_STATE_ID = "SET_STATE_ID",
  SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER",
  SET_PUSH_TOKEN = "SET_PUSH_TOKEN",
  SET_LOCALE = "SET_LOCALE",
}

export const enum ACTIONS {
  SET_STORY = "SET_STORY",
  GET_STATE = "GET_STATE",
  GET_STORIES = "GET_STORIES",
  GET_GAME = "GET_GAME",
  SET_STATE_ID = "SET_STATE_ID",
  SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER",
  SET_PUSH_TOKEN = "SET_PUSH_TOKEN",
  SET_LOCALE = "SET_LOCALE",
}

export const key: InjectionKey<Store<State>> = Symbol();

const mutations: MutationTree<State> = {
  [MUTATIONS.SET_GAME](state, newStory: Localizations) {
    state.game = newStory.localizations.get(state.locale);
  },
  [MUTATIONS.SET_STATE](state, newState: GameState) {
    state.gameState = newState;
    enablePushNotifications();
    // let's add some data
  },
  [MUTATIONS.SET_STATE_ID](state, newState: string) {
    state.gameStateId = newState;
  },
  [MUTATIONS.SET_STORIES](state, newState: Story[]) {
    state.stories = newState;
  },
  [MUTATIONS.SET_PUSH_TOKEN](state, newState: string) {
    state.pushToken = newState;
    sendToAPI();
  },
  [MUTATIONS.SET_LOGGED_IN_USER](state, newState: string) {
    state.username = newState;
    state.loggedIn = newState ? true : false;
  },
  [MUTATIONS.SET_LOCALE](state, newState: string) {
    state.locale = newState;
  },
};

const actions: ActionTree<State, any> = {
  [ACTIONS.SET_LOGGED_IN_USER](store, loggedIn: string) {
    store.commit(MUTATIONS.SET_LOGGED_IN_USER, loggedIn);
    store.commit(MUTATIONS.SET_STATE_ID, "");
    // store.commit(MUTATIONS.SET_GAME, NOSTORY);
  },
  
  [ACTIONS.SET_STATE_ID](store, id) {
    store.commit(MUTATIONS.SET_STATE_ID, id);
    return store.dispatch(ACTIONS.GET_STATE);
  },

  [ACTIONS.SET_PUSH_TOKEN](store, token) {
    store.commit(MUTATIONS.SET_PUSH_TOKEN, token);
  },
  [ACTIONS.SET_LOCALE](store, locale) {
    
    store.commit(MUTATIONS.SET_LOCALE, locale);
  },
  [ACTIONS.GET_STORIES](store) {
    return new Promise((resolve, reject) => {
      getLocalized("stories","json").then( result =>{
        const stories = result.data;
        console.log("result "+stories);
        store.commit(MUTATIONS.SET_STORIES, stories);
          resolve(stories);
      } ).catch(error => reject(error));
    })
  },
  [ACTIONS.GET_GAME](store, id: string) {
    Storage.get(`story-${id}.json`, { download: true }).then((result) => {
      function reviver(key: string, value: any) {
        if (typeof value === "object" && value !== null) {
          if (value.dataType === "Map") {
            return new Map(value.value);
          }
        }
        return value;
      }
      new Response(result.Body as BodyInit).text().then((text) => {
        console.log("got game");
        store.commit(MUTATIONS.SET_GAME, JSON.parse(text, reviver) as Localizations);
      });
    });
  },
  [ACTIONS.GET_STATE](store) {
    console.log(`loading state ${state.gameStateId}.json`);
    return Storage.get(`${state.gameStateId}.json`, { download: true }).then(
      (result) => {
        new Response(result.Body as BodyInit).text().then((res) => {
          console.log("result " + res);
          function reviver(key: string, value: any) {
            if (typeof value === "object" && value !== null) {
              if (value.dataType === "Map") {
                return new Map(value.value);
              }
            }
            return value;
          }
          const newValue: GameState = JSON.parse(res, reviver) as GameState;
          store.commit(MUTATIONS.SET_STATE, newValue);
          this.dispatch(ACTIONS.GET_GAME, newValue.story);
        });
      }
    );
  },
};

export const store = createStore<State>({ state, mutations, actions });

function enablePushNotifications() {
  if (Capacitor.getPlatform() !== "web") {
    PushNotifications.requestPermissions().then((result) => {
      console.log("result " + JSON.stringify(result));
      // Initialize the registration with FCM Token
      PushNotifications.register();
    });
    // On registration we can get the token
    PushNotifications.addListener("registration", (token) => {
      store.dispatch(ACTIONS.SET_PUSH_TOKEN, token.value);
    }).catch((error) => {
      console.log("error " + error);
      // alert("error " + error);
    });
  }
}
export function useStore() {
  return baseUseStore(key);
}
